import styled from "styled-components";

export const WheelCanvasStyle = styled.canvas`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
`;
